// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {AnchorSide} from './anchor-side.js'
import {Id} from './id.js'

export class CardinalAttachedEndpoint {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CardinalAttachedEndpoint {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  entity(obj?: Id): Id | null {
    return (obj || new Id()).__init(this.bb_pos, this.bb!)
  }

  side(): AnchorSide {
    return this.bb!.readInt8(this.bb_pos + 8)
  }

  static sizeOf(): number {
    return 12
  }

  static createCardinalAttachedEndpoint(
    builder: flatbuffers.Builder,
    entity_site: number,
    entity_timestamp: number,
    side: AnchorSide
  ): flatbuffers.Offset {
    builder.prep(4, 12)
    builder.pad(3)
    builder.writeInt8(side)
    builder.prep(4, 8)
    builder.writeInt32(entity_timestamp)
    builder.pad(2)
    builder.writeInt16(entity_site)
    return builder.offset()
  }
}
